import { configureStore } from '@reduxjs/toolkit';
import userDataReducer from './slices/UserSlice';
import permissionsReducer from './slices/PermissionsSlice';

export const store = configureStore({
  reducer: {
    user: userDataReducer,
    permissions: permissionsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
